export default "__VITE_ASSET__SjvFQfe0__"